// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-carousel-container[data-v-ebf5a2c2]{max-width:1024px;display:contents;flex-direction:column;width:available;width:-moz-available;width:-webkit-fill-available}div[data-v-ebf5a2c2]:has(>.product-group-style-action-link){margin-left:25px;margin-right:25px}.product-group-style-action-link[data-v-ebf5a2c2]{padding-top:4px;padding-bottom:4px;margin-bottom:16px;border-radius:15px}", ""]);
// Exports
module.exports = exports;
